import { IGlobalSort } from "../../global/state-helpers/sort";
import { IFilterableListResultsDto } from "../../global/dtos/filterable-list-results-dto";

export function GetSorts(allowedSorts: string[], sortField: string, inactiveSorts: string[] = null): IGlobalSort<IFilterableListResultsDto>[] {
    return allowedSorts.map((sort, i, arr) => {
        let newSort: IGlobalSort<IFilterableListResultsDto> = {
            display: sort,
            sortId: sort,
            selected: sortField ? sort.toLowerCase() === sortField.toLowerCase() : false,
            inactive: inactiveSorts.some(x => x.toLowerCase() === sort.toLowerCase())
        };
        return newSort;
    });
}

export enum ISearchDirection {
    ASCENDING,
    DESCENDING
}

export interface ISort {
    display: string;
    sortField: string;
    selected: boolean;
    direction: ISearchDirection;
    id: string;
}
